export const eventKeys = {
  all: ['events'] as const,

  getLatestCompetitionKey: () => [...eventKeys.all, 'latestCompetitions'] as const,
  getCompetitionEligibilityKey: () =>
    [...eventKeys.all, 'competitionEligibility'] as const,
  getParticipants: (params: any) =>
    [...eventKeys.all, 'getParticipants', JSON.stringify(params)] as const,
};
